import React from 'react';
import { Paper, Typography, Box, Avatar, Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from '../styles/components/Introduction.module.css';

const Introduction = () => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} className={styles.container}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={4}>
          <Box className={styles.avatarWrapper}>
            <Box className={styles.avatarGlow} />
            <Avatar
              alt="Financial Advisor"
              src="/logo.png"
              className={styles.avatar}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Typography variant="h4" className={styles.name}>
              {t('intro.name')}
            </Typography>
            <Typography variant="h6" className={styles.title}>
              {t('intro.title')}
            </Typography>
          </Box>
          <Typography variant="body1" paragraph className={styles.description}>
            {t('intro.description')}
          </Typography>
          <Typography variant="body1" className={styles.company}>
            {t('intro.company')}
          </Typography>
          <Box className={styles.buttonContainer}>
            <Button 
              variant="contained" 
              color="primary" 
              size="large" 
              className={styles.primaryButton}
            >
              Contact Now
            </Button>
            <Button 
              variant="outlined" 
              color="primary" 
              size="large" 
              className={styles.secondaryButton}
            >
              Learn More
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Introduction; 